import { format } from "date-fns";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom, Observable, of } from "rxjs";
import { Timeline } from "./timeline.types";

@Injectable({
    providedIn: 'root'
})
export class TimelineService {

    constructor(private http: HttpClient) { }

    timeline(start: Date, end: Date, teamId: string): Observable<Timeline> {

        const emptyTimeline: Observable<Timeline> = of( {
            days:[]
        })

        const timeline: () => Observable<Timeline> = () => {
            if(teamId) {
                const params = {
                    start: format(start, 'dd-MM-yyyy'),
                    end: format(end, 'dd-MM-yyyy'),
                };
                return this.http.get<Timeline>('/api/' + teamId + '/timeline', {params: params});
            } else {
                return emptyTimeline;
            }
        }

        return timeline();
    }
}